import { Button, LoadingSpinner, Modal, Text } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import classnames from "classnames"

interface DownloadPayrollBreakdownProps {
  setShowModal: (show: boolean) => void
  onDownloadPrefundingBreakdown?: () => void
  onDownloadPayrollBreakdown?: () => void
  loading?: boolean
}

function DownloadItem({
  translationKey,
  onClick,
}: {
  translationKey: string
  onClick?: () => void
}) {
  const { t } = useTranslation("components/DownloadPayrollBreakdown", { keyPrefix: translationKey })

  return (
    <div>
      <Text className="font-semibold" size="medium">
        {t("title")}
      </Text>
      <Text className="mb-4 text-gray-400" size="medium">
        {t("description")}
      </Text>
      <Button disabled={!onClick} onClick={onClick} size="sm" variation="primary">
        {t("download")}
      </Button>
    </div>
  )
}

export function DownloadPayrollBreakdownModal({
  onDownloadPayrollBreakdown,
  onDownloadPrefundingBreakdown,
  setShowModal,
  loading,
}: DownloadPayrollBreakdownProps) {
  const { t } = useTranslation("components/DownloadPayrollBreakdown")
  const cancel = () => setShowModal(false)

  return (
    <Modal
      isOpen
      data-testid="download-payroll-breakdown"
      onRequestClose={() => setShowModal(false)}
    >
      <Modal.Header>{t("title")}</Modal.Header>
      <Modal.Content>
        <div
          aria-live="polite"
          aria-busy={Boolean(loading)}
          className="relative"
          data-testid="download-payroll-breakdown-wrapper"
        >
          {loading && (
            <div
              className="pointer-events-none absolute inset-0 grid place-items-center"
              role="progressbar"
            >
              <div className="flex items-center gap-2">
                {t("loading")}
                <LoadingSpinner />
              </div>
            </div>
          )}
          <div
            className={classnames("flex flex-col gap-8", {
              "opacity-20": loading,
            })}
          >
            <DownloadItem translationKey="prefunding" onClick={onDownloadPrefundingBreakdown} />

            <DownloadItem translationKey="payroll" onClick={onDownloadPayrollBreakdown} />

            <Button onClick={cancel} variation="secondary">
              {t("cancel")}
            </Button>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  )
}
